module.exports = __webpack_public_path__ + "img/btn.7baf5f3f.png";